import { ReactNode } from 'react';

import { Text } from '@spotify-internal/encore-web';

import styles from './MetadataText.module.css';

type MetadataTextProps = {
  items: ReactNode[];
  className?: string;
};

export const MetadataText = ({
  items,
  className,
}: MetadataTextProps): JSX.Element | null => {
  const filtered = items.filter(
    item =>
      item !== null && item !== undefined && item !== '' && item !== false,
  );

  if (filtered.length === 0) return null;

  return (
    <Text
      as="div"
      variant="marginal"
      semanticColor="textSubdued"
      className={className}
    >
      {filtered.map((item, index) => (
        <span key={index} className={styles.item}>
          {item}
        </span>
      ))}
    </Text>
  );
};
